import { ProposalNode } from '@/apollo/graphql'
import { customerDisplayLabel } from '@/utils'
import { getDealFinancialBuildData } from '@/pages/Deals/utils'
import { useApp } from '@/hooks'
import moment from 'moment'
import { DATE_TIME_FORMAT } from '@/constants'

export const useBuildData = (selectedItem?: Partial<ProposalNode>) => {
  const { generalSettings } = useApp()
  return {
    general_info: [
      {
        name: 'id',
        label: 'id',
        type: 'text',
        editable: false,
        className: 'w-50',
        value: selectedItem?.id,
      },
      {
        label: 'status',
        value: 'Ready',
        style: { color: '#36af69' },
      },
      {
        label: 'dealTypeString',
        editable: false,
        value: selectedItem?.dealTypeString,
      },
      {
        name: 'leaseDuration',
        className: 'w-50',
        label: 'lease_duration',
        value: selectedItem?.leaseDuration,
      },
      {
        label: 'creation_time',
        editable: false,
        value: moment(selectedItem?.creationTime).format(DATE_TIME_FORMAT),
      },
      {
        label: 'customer',
        value: customerDisplayLabel(selectedItem?.customer),
        link: `/${selectedItem?.customer?.id}/main`,
      },
      {
        label: 'car_sub_model',
        value: selectedItem?.carSubModel?.name,
      },
      {
        label: 'car_model',
        value: selectedItem?.carSubModel?.carModel.name,
      },
      {
        label: 'car_brand',
        value: selectedItem?.carSubModel?.carModel.brand.name,
      },
    ],
    financial_details: getDealFinancialBuildData(
      selectedItem as any,
      generalSettings,
    ),
  }
}
